module.exports = {
	"articleTitle1": "Flooding forces cancellation of classes in North Quad",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "North Quad",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/north-quad-preparing-fall-departments-moving",
	"articleSnippet1": "Mar 28, 2013 ... Around 10:30 a.m. Thursday morning, a pipe broke at the North Quad Residential \nand Academic Complex and began flooding student living ...",
	"articleSnippet2": "Jul 25, 2010 ... As the construction progresses, four academic units and the School of \nInformation prepare for their transition into North Quad, bringing with ...",
	"totalMisc": 1,
	"articleTitle2": "North Quad to showcase state-of-the-art technology, international ...",
	"address": "105 S State St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161208/cmm.NEW_.DiversityNext.12.7.16036%20copy.JPG?itok=35mm-geT",
			"author": "Claire Meingas",
			"caption": "Theatre & Drama Prof. Anita Gonzalez and Dance Associate Prof. Robin Wilson discuss diversity in the arts for the Diversity Next! series at North Quad Wednesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/ava.FEA_.BSIProjectExposition.4.13.16.37_0.jpg?itok=B5s0MdNS",
			"author": "Ava Randa",
			"caption": "Information Senior Josh Blumberg presents his final project at the BSI Project Exposition in North Quad Wednesday."
		}
	],
	"position": {
		"lat": 42.280732,
		"lng": -83.740025
	},
	"tips": [
		{
			"text": "I'm really into sneaking into buildings I'm not allowed in, but the 10th floor of North Quad is always quiet, the view of the sunset is always beautiful and it's relatively easy to get into.",
			"person": "Shivangi Sharma"
		}
	],
	"bathroomrating": [
		{
			"rating": 4,
			"bathroom": "1st floor restroom near elevators"
		},
		{
			"rating": 5,
			"bathroom": "Basement restroom near elevators"
		},
		{
			"rating": 4,
			"bathroom": "10th Floor"
		}
	],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/northquad.json
// module id = 933
// module chunks = 0